import { PropertyProgressAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import {
  IGetPropertyProgressDTO,
  IGetPropertyProgressResponse,
  IResetPropertyStepDTO,
  IResetPropertyStepResponse,
  IStopPropertyAdDTO,
  TPropertyAdActionResponse,
} from '@/models/propertyProgress.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PROPERTY_PROGRESS_SLICE_NAME } from './models';

export const getPropertyProgress = createAsyncThunk<
  IGetPropertyProgressResponse,
  IGetPropertyProgressDTO,
  { serializedErrorType: IApiError }
>(
  `${PROPERTY_PROGRESS_SLICE_NAME}/getPropertyProgress`,
  async (data) => {
    const response = await PropertyProgressAPI.getPropertyProgress(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const resetPropertyStep = createAsyncThunk<
  IResetPropertyStepResponse,
  IResetPropertyStepDTO,
  { serializedErrorType: IApiError }
>(
  `${PROPERTY_PROGRESS_SLICE_NAME}/resetPropertyStep`,
  async (id) => {
    const response = await PropertyProgressAPI.resetPropertyStep(id);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const stopPropertyAd = createAsyncThunk<
  TPropertyAdActionResponse,
  IStopPropertyAdDTO,
  { serializedErrorType: IApiError }
>(
  `${PROPERTY_PROGRESS_SLICE_NAME}/stopPropertyAd`,
  async (data) => {
    const response = await PropertyProgressAPI.stopPropertyAd(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
